import React from 'react';
import { Modal, Button } from 'ui/components';
import { BootstrapSizes, Theme } from 'ui/Helpers/utils';

export default function ModalAcimaSeguro(props) {
  const { show, data } = props;

  const onSend = (e) => {
    props.onClose(e, data);
  };

  return (
    <Modal
      show={show}
      title='Atenção'
      onClose={() => onSend()}
      size={BootstrapSizes.Large}
    >
      <Modal.Body>
        <div className='row'>
          <div className='row mb-3'>
            <span>
              O valor do documento informado é acima do valor de cobertura do
              seguro.
            </span>
          </div>
          <div className='row mb-3'>
            <span>Deseja continuar?</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          size={BootstrapSizes.Small}
          icon='check'
          theme={Theme.Success}
          template={Button.Templates.Default}
          onClick={() => onSend(true)}
          text='Confirmar'
        />
        <Button
          size={BootstrapSizes.Small}
          icon={['fas', 'times']}
          theme={Theme.Danger}
          template={Button.Templates.Default}
          onClick={() => onSend(false)}
          text='Cancelar'
        />
      </Modal.Footer>
    </Modal>
  );
}
